import BasicRouterView from "../../components/BasicRouterView.vue";

const cseRoutes = {
  path: "cse",
  redirect: { name: "cse-historico" },
  meta: {
    label: "Controle Emocional",
    icon: "groups",
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "controle-de-seguranca-emocional/historico",
      name: "cse-historico",
      meta: {
        label: "Historico",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "cse" */ "./views/Historico.vue"),
    },
    {
      path: "controle-de-seguranca-emocional/responder",
      name: "cse-responder",
      meta: {
        label: "Responder",
        icon: "task_alt",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "cse" */ "./views/Responder.vue"),
    },
    {
      path: "controle-de-seguranca-emocional/administrador",
      name: "cse-administrador",
      meta: {
        label: "Administrador",
        icon: "badge",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "cse" */ "./views/Administrador.vue"),
    },
    {
      path: "controle-de-seguranca-emocional/alerta",
      name: "cse-alerta",
      meta: {
        label: "Alertas",
        icon: "notifications",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "cse" */ "./views/AlertaConfigCse.vue"),
    },
  ],
};

export default cseRoutes;
